import React, { useEffect, useState } from "react";
import { CircleBtn } from "assets/css/globle";
import { COMMON_SERVICES } from "../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import { useHookstate } from "@hookstate/core";
import { Loader } from "commonComponents/Loader/Loader";
import { DataGrid } from "@mui/x-data-grid";
import { API_STATUSES } from "redux/_helpers/statuses";
import { TableContainer, BodyWrapper } from "assets/css/globle";
import { getFeatureSetOption, getFeaturesList } from "../../../constant";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { Header, TableInnerSection } from "../Inbox/InboxStyled";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";

export const Announcements = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const {
    siteSettingDataReduxStateStatus,
    getAnnouncementsData,
    siteSettingsData,
    acknowledgeAnnouncementsStatus,
    getUserRole,
  } = useSelector((state) => state.commonReducers) || [];
  const [messageData, setMessageData] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const dispatch = useDispatch();

  const decodeHtml = (html) => {
    if (!html) return '';
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  const formatDateTime = (utcDateTime, timezoneOffset) => {
    if (!utcDateTime) return '';
    const dateTime = moment.utc(utcDateTime);
    if (timezoneOffset) {
      dateTime.utcOffset(-timezoneOffset);
    }
    return dateTime.format("MM/DD/YYYY hh:mm a");
  };

  const isDefaultDateTime = (dateTime) => {
    return !dateTime || dateTime.startsWith("0001-01-01");
  };

  useEffect(() => {
    dispatch(COMMON_SERVICES.getAnnouncementsServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    setMessageData([]);
  }, [siteId.get()]);

  useEffect(() => {
    let messageDataGetter = [];
    if (
      getAnnouncementsData &&
      getAnnouncementsData?.Messages &&
      getAnnouncementsData?.Messages?.length !== 0
    ) {
      messageDataGetter = getAnnouncementsData?.Messages;
    }
    setMessageData(messageDataGetter);
  }, [getAnnouncementsData]);

  useEffect(() => {
    if (acknowledgeAnnouncementsStatus === API_STATUSES.SUCCESS) {
      dispatch(COMMON_SERVICES.getAnnouncementsServices(siteId.get()));
      setSelectionModel([]);
    }
  }, [acknowledgeAnnouncementsStatus]);

  const handleAcknowledgeSelected = () => {
    const username = getUserRole?.Name || "";
    dispatch(
      COMMON_SERVICES.acknowledgeAnnouncementsServices(siteId.get(), selectionModel, username)
    );
  };

  const getRowHeight = (params) => {
    const content = `${params?.model?.Text}`;
    return content.length > 100 ? 100 : 50;
  };

  const columns = [
    {
      field: "Created",
      headerName: t("Created"),
      width: 180,
      headerClassName: "lastcolumnSeparator display",
      renderCell: (params) => (
        <div className="super-time-theme--cell">
          {formatDateTime(params.row.Created, siteSettingsData?.TimeZoneOffset)}
        </div>
      ),
    },
    {
      field: "Title",
      headerName: t("Title"),
      flex: 1,
      minWidth: 250,
      type: "string",
      headerClassName: "lastcolumnSeparator text-column",
      cellClassName: "word-wrap",
      renderCell: (params) => (
        <div className="time-theme--cell">{decodeHtml(params.row?.Title)}</div>
      ),
    },
    {
      field: "Text",
      headerName: t("Text"),
      flex: 1,
      minWidth: 450,
      type: "string",
      headerClassName: "lastcolumnSeparator text-column",
      cellClassName: "word-wrap",
      renderCell: (params) => (
        <div className="time-theme--cell">{decodeHtml(params.row?.Text)}</div>
      ),
    },
    {
      field: "Severity",
      headerName: t("Severity"),
      flex: 1,
      minWidth: 200,
      type: "string",
      headerClassName: "lastcolumnSeparator text-column",
      cellClassName: "word-wrap",
      renderCell: (params) => (
        <div className="time-theme--cell">{decodeHtml(params.row?.Severity)}</div>
      ),
    },
    {
      field: "AnnouncementType",
      headerName: t("Announcement_Type"),
      flex: 1,
      minWidth: 200,
      type: "string",
      headerClassName: "lastcolumnSeparator text-column",
      cellClassName: "word-wrap",
      renderCell: (params) => (
        <div className="time-theme--cell">{decodeHtml(params.row?.AnnouncementType)}</div>
      ),
    },
    {
      field: "SentBy",
      headerName: t("Sent_By"),
      flex: 1,
      minWidth: 150,
      type: "string",
      headerClassName: "lastcolumnSeparator text-column",
      cellClassName: "word-wrap",
      renderCell: (params) => (
        <div className="time-theme--cell">{decodeHtml(params.row?.SentBy)}</div>
      ),
    },
    {
      field: "ExpirationDateTime",
      headerName: t("Expires"),
      width: 180,
      headerClassName: "lastcolumnSeparator display",
      renderCell: (params) => {
        if (isDefaultDateTime(params.row?.ExpirationDateTime)) {
          return <div className="super-time-theme--cell">-</div>;
        }
        return (
          <div className="super-time-theme--cell">
            {formatDateTime(params.row.ExpirationDateTime, siteSettingsData?.TimeZoneOffset)}
          </div>
        );
      },
    },
  ];

  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST) {
    return <Loader />;
  }

  return (
    !getFeatureSetOption(
      siteSettingsData && siteSettingsData?.Features,
      getFeaturesList().real_time_tracking
    ) && (
      <>
        <Header>
          <CircleBtn
            disabled={selectionModel.length === 0}
            onClick={handleAcknowledgeSelected}
            style={{
              opacity: selectionModel.length === 0 ? 0.5 : 1,
              cursor: selectionModel.length === 0 ? "not-allowed" : "pointer",
            }}
          >
            {t("Acknowledge_Selected")} ({selectionModel.length})
          </CircleBtn>
        </Header>
        <TableContainer className="inbox-table">
          <BodyWrapper>
            <TableInnerSection>
              <DataGrid
                className="inbox"
                hideFooter={true}
                checkboxSelection
                isRowSelectable={(params) => !params.row.IsAcknowledged}
                onSelectionModelChange={(newSelection) => {
                  setSelectionModel(newSelection);
                }}
                selectionModel={selectionModel}
                components={{
                  NoRowsOverlay: () => (
                    <Stack
                      height="100%"
                      alignItems="center"
                      justifyContent="center"
                      fontSize={25}
                      fontWeight="bold"
                    >
                      {t("Inbox_is_empty")}
                    </Stack>
                  ),
                }}
                rows={messageData ? messageData : []}
                columns={columns}
                getRowHeight={getRowHeight}
                disableSelectionOnClick
                disableColumnMenu
                getRowId={(r) => r.Id}
              />
            </TableInnerSection>
          </BodyWrapper>
        </TableContainer>
      </>
    )
  );
};

